import React from 'react';
import ReactTooltip from 'react-tooltip';
import { Loader, BaasicModal, BaasicConfirmModal, Collapsible, BaasicCheckbox, BaasicHeader } from 'core/components';
import { observer } from 'mobx-react';
import { defaultTemplate } from 'core/hoc';
import { isSome } from 'core/utils';
import {
	FulfillmentOrderItemsList,
	FulfillmentOrderHistoryLogList,
	AssignCarrierServiceAndWarehouse,
	OnHold,
	ChangeShipping,
	StatusChange,
	VoidLabel,
	NeverShipped,
	MarkAsShipped,
	FulfillmentOrderErrorLogList,
	EditOrder,
	SplitFulfillmentOrder,
} from 'modules/order/pages';
import {
	onAssignStatuses,
	onHoldStatuses,
	onCancelStatuses,
	onPullLabelStatuses,
	onChangeShippingStatuses,
	onProductionModeStatuses,
	onStatusChangeStatuses,
	onNeverShippedStatuses,
	onReoptimizeStatuses,
	onHoldReason,
	onMarkAsShippedStatuses,
	onSplitFulfillmentOrderStatuses,
	channelType,
	voidLabelStatuses,
} from 'common/constants';
import { CostBreakdownTooltip } from 'common/tooltips';
import ResizeObserver from 'react-resize-observer';
import { translate, formatDate } from 'core/utils';
import _ from 'lodash';

const OrderDetailTemplate = ({
	orderDetailViewStore,
	orderDetailViewStore: {
		canCancel,
		loading,
		rootStore,
		fulfillmentOrderItems,
		activeShipmentInfo,
		pdfURL,
		printLabel,
		printPackingSlip,
		isPrintingPackingSlipAllowed,
		pullLabelConfirmModal,
		assignmentModal,
		editOrderModal,
		onHoldModal,
		changeShippingModal,
		statusChangeModal,
		cancelConfirmModal,
		voidLabelModal,
		voidLabelConfirmModal,
		neverShippedModal,
		markAsShippedModal,
		fulfillmentOrderStore: { item },
		isSeller,
		isSuperAdminOrganization,
		displayPopoverButton,
		errorLogModal,
		format,
		timezone,
		productionModeConfirmModal,
		pullLabelProductionModeConfirmModal,
		reoptimizeConfirmModal,
		itemPrice,
		order,
		isVendorOrder,
		getWarehouseCodesForDisplay,
		isReentered,
		splitFulfillmentOrderModal,
		orderAddressData,
	},
	t,
}) => {
	if (loading) return <Loader />;
	return (
		<React.Fragment>
			<ReactTooltip />
			<div className="order">
				<BaasicHeader title="ORDERDETAILVIEW.ORDERDETAILS" rootStore={rootStore}>
					<ResizeObserver
						onResize={rect => {
							displayPopoverButton(rect.width);
						}}
					/>
					<ActionsRender viewStore={orderDetailViewStore} t={t} />
				</BaasicHeader>
				<div className="order__wrapper">
					<div className="order__header">
						<div className="container--fluid">
							<div className="order__header__wrapper">
								<div className="order__header__column">
									<div className="order__header__item">
										<h4 className="order__header__title type--base">{t('ORDERDETAILVIEW.FULFILLMENTORDERID')}</h4>
										<p>{item.fulfillmentOrderId}</p>
									</div>
								</div>
								{item.internalNote != '' && item.internalNote != null && (
									<div className="order__header__column">
										<div className="order__header__item">
											<h4 className="order__header__title type--base">{t('ORDERDETAILVIEW.NOTE')}</h4>
											<p>{item.internalNote}</p>
										</div>
									</div>
								)}
								<div className="order__header__column">
									<div className="order__header__item">
										<h4 className="order__header__title type--base">{t('ORDERDETAILVIEW.ORDERNUMBER')}</h4>
										{(isSeller || isSuperAdminOrganization) &&
										item.order.channel.channelType.abrv === channelType.amazon.toLowerCase() ? (
											<a
												href={'https://sellercentral.amazon.com/orders-v3/order/' + item.order.orderNumber}
												target="_blank"
											>
												{item.order.orderNumber}
											</a>
										) : (
											<p>{item.order.orderNumber}</p>
										)}
									</div>
								</div>
								<div className="order__header__column">
									<div className="order__header__item">
										<h4 className="order__header__title type--base">{t('ORDERDETAILVIEW.FULFILLMENTORDERSTATUS')}</h4>
										<p>{item.fulfillmentOrderStatus.name}</p>
									</div>
								</div>
								{item.cancelReason != null && (
									<div className="order__header__column">
										<div className="order__header__item">
											<h4 className="order__header__title type--base">{t('ORDERDETAILVIEW.CANCELREASON')}</h4>
											<p>{item.cancelReason ? item.cancelReason.name : '-'}</p>
										</div>
									</div>
								)}
								{item.replacementReason != null && (
									<div className="order__header__column">
										<div className="order__header__item">
											<h4 className="order__header__title type--base">{t('ORDERDETAILVIEW.REPLACEMENTREASON')}</h4>
											<p>{item.replacementReason ? item.replacementReason.name : '-'}</p>
										</div>
									</div>
								)}
								{activeShipmentInfo != null && (
									<div className="order__header__column">
										<div className="order__header__item">
											<h4 className="order__header__title type--base">{t('ORDERDETAILVIEW.TRACKINGNUMBER')}</h4>
											<p>{activeShipmentInfo.trackingNumber}</p>
										</div>
									</div>
								)}
								{/* On Hold reason */}
								<div className="order__header__column">
									<div className="order__header__item">
										<h4 className="order__header__title type--base">{t('ORDERDETAILVIEW.ONHOLDREASON')}</h4>
										<p>{item.onHoldReason ? item.onHoldReason.name : '-'}</p>
									</div>
								</div>
								{activeShipmentInfo != null && (
									<div className="order__header__column">
										<div className="order__header__item">
											<h4 className="order__header__title type--base">{t('ORDERDETAILVIEW.ISBUYSHIPPING')}</h4>
											<p>
												{activeShipmentInfo.isBuyShipping ? (
													<i className="type--color--success fas fa-check-circle" />
												) : (
													<i className="fas fa-times-circle"></i>
												)}
											</p>
										</div>
									</div>
								)}
								<div className="order__header__column">
									<div className="order__header__item">
										<h4 className="order__header__title type--base">{t('ORDERDETAILVIEW.ISPRIME')}</h4>
										{item.order.isPrime ? (
											<i className="icon icon--xlrg icon--prime" />
										) : (
											<i className="icon icon--xlrg icon--prime--grey" />
										)}
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="order__details">
						<div className="container--fluid">
							<div className="row">
								<div className="col col-sml-12">
									<div className="order__box">
										<h4 className="order__box__title">{t('GENERALINFORMATION')}</h4>
										<div className="order__box__content">
											<div
												className={
													item.productionMode
														? 'flex__wrapper flex__wrapper--justify--between is-warning'
														: 'flex__wrapper flex__wrapper--justify--between'
												}
											>
												<div className="flex__column">
													<div>
														<div className="order__header__item">
															<h4 className="order__header__title">{t('ORDERDETAILVIEW.CUSTOMER')}</h4>
														</div>
														<div className="order__box__content">
															{orderAddressData.buyerName != null && (
																<span>
																	<p className="order__label">{t('ORDERDETAILVIEW.CUSTOMERNAME')}</p>
																	<p className="fs-mask">{orderAddressData.buyerName}</p>
																</span>
															)}

															<p className="order__label spc--top--sml">{t('ORDERDETAILVIEW.EMAIL')}</p>
															<p>{orderAddressData.buyerEmail}</p>

															<p className="order__label spc--top--sml">
																<span>{t('ORDERDETAILVIEW.ADDRESS')}</span>
																{orderAddressData.addressChanged && (
																	<i
																		data-tip={t('ORDERVIEW.ADDRESSCHANGED')}
																		className="icon icon--xmed icon--location-check--primary spc--left--nano"
																	></i>
																)}
															</p>
															<p className="fs-mask">{orderAddressData.buyerName}</p>
															<p className="fs-mask">{orderAddressData.shippingAddress1}</p>
															{orderAddressData.shippingAddress2 != '' && (
																<p className="fs-mask">{orderAddressData.shippingAddress2}</p>
															)}
															{orderAddressData.shippingAddress3 != '' && (
																<p className="fs-mask">{orderAddressData.shippingAddress3}</p>
															)}
															<p>
																{orderAddressData.shippingCity},{' '}
																{orderAddressData.shippingCoreCountryState
																	? orderAddressData.shippingCoreCountryState.name
																	: null}{' '}
																{orderAddressData.shippingZipCode}
															</p>
															{orderAddressData.buyerPhone != null && (
																<span>
																	<p className="order__label spc--top--sml">{t('ORDERDETAILVIEW.PHONE')}</p>
																	<p className="fs-mask">{orderAddressData.buyerPhone}</p>
																</span>
															)}
														</div>
													</div>
												</div>
												<div className="flex__column">
													<div>
														<div className="order__header__item">
															<h4 className="order__header__title">{t('ORDERDETAILVIEW.SHIPPING')}</h4>
														</div>
														<div className="order__box__content">
															<p className="order__label">
																<span>{t('ORDERDETAILVIEW.ADDRESS')}</span>
																{orderAddressData.addressChanged && (
																	<i
																		data-tip={t('ORDERVIEW.ADDRESSCHANGED')}
																		className="icon icon--xmed icon--location-check--primary spc--left--nano"
																	></i>
																)}
															</p>
															<p className="fs-mask">{orderAddressData.buyerName}</p>
															<p className="fs-mask">{orderAddressData.shippingAddress1}</p>
															{orderAddressData.shippingAddress2 != '' && (
																<p className="fs-mask">{orderAddressData.shippingAddress2}</p>
															)}
															{orderAddressData.shippingAddress3 != '' && (
																<p className="fs-mask">{orderAddressData.shippingAddress3}</p>
															)}
															<p>
																{orderAddressData.shippingCity},{' '}
																{orderAddressData.shippingCoreCountryState
																	? orderAddressData.shippingCoreCountryState.name
																	: null}{' '}
																{orderAddressData.shippingZipCode}
															</p>
															{orderAddressData.buyerPhone != null && (
																<span>
																	<p className="order__label spc--top--sml">{t('ORDERDETAILVIEW.PHONE')}</p>
																	<p className="fs-mask">{orderAddressData.buyerPhone}</p>
																</span>
															)}
															<p className="order__label spc--top--sml">
																{t('ORDERDETAILVIEW.ASSIGNEDCARRIERSERVICE')}
															</p>
															<p>{item.carrierService ? item.carrierService.name : '-'}</p>

															<span>
																<p className="order__label spc--top--sml">{t('ORDERDETAILVIEW.ASSIGNEDCARRIER')}</p>
																{item.carrier ? item.carrier.name : '-'}
															</span>

															<p className="order__label spc--top--sml">{t('ORDERDETAILVIEW.SHIPBYDATE')}</p>
															{isReentered && (
																<React.Fragment>
																	{formatDate(item.newShipByDate, false, 'L')}
																	<i
																		data-tip={t('TOOLTIP.NEWSHIPBYDATE', {
																			date: formatDate(item.shipByDate, false, 'L'),
																		})}
																		className="spc--left--tny fas fa-exclamation-circle"
																	/>
																</React.Fragment>
															)}
															{!isReentered && <p>{formatDate(item.shipByDate, false, 'L')}</p>}

															{activeShipmentInfo && (
																<span>
																	<p className="order__label spc--top--sml">{t('ORDERDETAILVIEW.SHIPPINGCOST')}</p>
																	{activeShipmentInfo.shippingCostSurcharge != 0 ? (
																		<React.Fragment>
																			<p className="order__highlight">{`$${activeShipmentInfo.shippingCostTotal}`}</p>
																			<CostBreakdownTooltip
																				idValue={activeShipmentInfo.id}
																				shippingCost={activeShipmentInfo.cost}
																				surplusCharge={activeShipmentInfo.shippingCostSurcharge}
																				total={activeShipmentInfo.shippingCostTotal}
																				displayIcon={true}
																			/>
																		</React.Fragment>
																	) : (
																		<p>{`$${activeShipmentInfo.cost}`}</p>
																	)}
																</span>
															)}
															<span>
																<p className="order__label spc--top--sml">{t('ORDERDETAILVIEW.ASSIGNEDRATE')}</p>
																{isSome(item.assignedRate) ? (
																	!(item.assignedRateSurcharge == null || item.assignedRateSurcharge == 0) ? (
																		<React.Fragment>
																			<p className="order__highlight">{`$${item.assignedRateTotal}`}</p>
																			<CostBreakdownTooltip
																				idValue={item.id}
																				shippingCost={item.assignedRate}
																				surplusCharge={item.assignedRateSurcharge}
																				total={item.assignedRateTotal}
																				displayIcon={true}
																			/>
																		</React.Fragment>
																	) : (
																		<p>{`$${item.assignedRate}`}</p>
																	)
																) : (
																	<p>{'-'}</p>
																)}
															</span>
															<span>
																<p className="order__label spc--top--sml">{t('ORDERDETAILVIEW.ZONE')}</p>
																{activeShipmentInfo ? activeShipmentInfo.zone : '-'}
															</span>
														</div>
													</div>
												</div>
												<div className="flex__column">
													<div>
														<div className="order__header__item">
															<h4 className="order__header__title">{t('ORDERDETAILVIEW.WAREHOUSE')}</h4>
														</div>
														<div className="order__box__content">
															<p className="order__label">{t('ORDERDETAILVIEW.WAREHOUSENAME')}</p>
															<p>{item.warehouseOrganization ? item.warehouseOrganization.applicationTitle : '-'}</p>

															<p className="order__label spc--top--sml">{t('ORDERDETAILVIEW.CODE')}</p>
															<p>
																{item.warehouseOrganization && item.warehouseOrganization.convertWarehouses
																	? getWarehouseCodesForDisplay(item)
																	: '-'}
															</p>
														</div>
														{isVendorOrder && (
															<div>
																<div className="order__header__item">
																	<h4 className="order__header__title">{t('ORDERDETAILVIEW.REQUIREDSHIPPING')}</h4>
																</div>
																<div className="order__box__content">
																	<p className="order__label">{t('ORDERDETAILVIEW.REQUIREDWAREHOUSE')}</p>
																	<p>{item.order.requiredWarehouse}</p>

																	<p className="order__label spc--top--sml">
																		{t('ORDERDETAILVIEW.REQUIREDCARRIERSERVICE')}
																	</p>
																	<p>{item.order.requiredCarrierService}</p>
																</div>
															</div>
														)}
													</div>
												</div>
												<div className="flex__column flex__column--order">
													<div>
														<div className="order__header__item">
															<h4 className="order__header__title">{t('ORDERDETAILVIEW.MASTERORDER')}</h4>
														</div>
														<div className="order__box__content">
															<p className="order__label">{t('ORDERDETAILVIEW.ORDERDATE')}</p>
															<p>{formatDate(item.order.orderDate, true, 'LLL')}</p>

															{item.order.customerServiceOrderNumber != '' && (
																<React.Fragment>
																	<div className="separator--primary spc--top--sml spc--bottom--sml"></div>
																	<p className="order__label">{t('ORDERDETAILVIEW.CUSTOMERSERVICEORDERNUMBER')}</p>
																	<p>{item.order.customerServiceOrderNumber}</p>
																</React.Fragment>
															)}

															{item.order.source != '' && (
																<React.Fragment>
																	<div className="separator--primary spc--top--sml spc--bottom--sml"></div>
																	<p className="order__label">{t('ORDERDETAILVIEW.CHANNELSOURCE')}</p>
																	<p>{item.order.source}</p>
																</React.Fragment>
															)}

															<div className="separator--primary spc--top--sml spc--bottom--sml"></div>

															<div className="row">
																<div className="col col-sml-6">
																	<p className="order__label">{t('ORDERDETAILVIEW.ITEMPRICE')}</p>
																</div>
																<div className="col col-sml-6">
																	<p className="type--right">{itemPrice}</p>
																</div>
															</div>

															<div className="row spc--top--sml">
																<div className="col col-sml-6">
																	<p className="order__label">{t('ORDERDETAILVIEW.TOTALTAX')}</p>
																</div>
																<div className="col col-sml-6">
																	<p className="type--right">{order.taxPaid}</p>
																</div>
															</div>
															<div className="row spc--top--sml">
																<div className="col col-sml-6">
																	<p className="order__label">{t('ORDERDETAILVIEW.TOTALSHIPPING')}</p>
																</div>
																<div className="col col-sml-6">
																	<p className="type--right">{order.shippingPaid}</p>
																</div>
															</div>
															<div className="row spc--top--sml">
																<div className="col col-sml-6">
																	<p className="order__label">{t('ORDERDETAILVIEW.SUBTOTAL')}</p>
																</div>
																<div className="col col-sml-6">
																	<p className="type--right">{itemPrice}</p>
																</div>
															</div>
															<div className="row spc--top--sml">
																<div className="col col-sml-6">
																	<p className="order__label">{t('ORDERDETAILVIEW.DISCOUNT')}</p>
																</div>
																<div className="col col-sml-6">
																	<p className="type--right">{order.discount*-1}</p>
																</div>
															</div>
															<div className="row spc--top--sml">
																<div className="col col-sml-6">
																	<p className="order__label type--lrg">{t('ORDERDETAILVIEW.TOTALPAID')}</p>
																</div>
																<div className="col col-sml-6">
																	<p className="type--right type--lrg">{order.amountPaid}</p>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							{item.shipmentInfos.length > 0 &&
								_.every(item.shipmentInfos, shipmentInfo => {
									return shipmentInfo.trackingNumber.length !== 0;
								}) && (
									<div className="row spc--top--sml">
										<div className="col col-sml-12">
											<div className="order__box">
												<h4 className="order__box__title">{t('ORDERDETAILVIEW.LABELS')}</h4>
												<div className="order__box__content">
													<div className="flex__wrapper flex__wrapper--justify--between">
														<div className="flex__column">
															{item.shipmentInfos.length > 0 && (
																<span className="order__label">{t('ORDERDETAILVIEW.TRACKINGNUMBERS')}:</span>
															)}
															{_.map(item.shipmentInfos, (label, idx) => {
																if (label.shipmentInfoStatus.abrv === 'voided') {
																	return (
																		<p
																			key={idx}
																			style={
																				label.shipmentInfoStatus.abrv === 'voided'
																					? { textDecoration: 'line-through', color: 'grey' }
																					: {}
																			}
																		>
																			{label.trackingNumber}
																		</p>
																	);
																} else {
																	return isSome(item.carrierService) ? (
																		<p key={idx}>
																			<a
																				href={
																					item.carrierService.name.includes('USPS')
																						? 'https://www.stamps.com/tracking-details/?t=' + label.trackingNumber
																						: item.carrierService.name.includes('FedEx')
																						? 'https://www.fedex.com/apps/fedextrack/?action=track&language=english&tracknumbers=' +
																						  label.trackingNumber
																						: 'https://www.ups.com/track?loc=en_US&requester=QUIC&tracknum=' +
																						  label.trackingNumber.split('-')[0]
																				}
																				target="_blank"
																			>
																				{label.trackingNumber}
																			</a>
																		</p>
																	) : (
																		<p key={idx}>{label.trackingNumber}</p>
																	);
																}
															})}
															{/* Print Label */}
															{pdfURL && !canCancel && (
																<button
																	className="btn btn--med btn--primary spc--top--med spc--right--sml"
																	type="button"
																	onClick={printLabel}
																>
																	{t('PRINTLABEL')}
																</button>
															)}
															{isPrintingPackingSlipAllowed && (
																<button
																	className="btn btn--med btn--primary spc--top--med spc--right--sml"
																	type="button"
																	onClick={printPackingSlip}
																>
																	{t('PRINTPACKINGSLIP')}
																</button>
															)}
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								)}
						</div>
						<div className="order__box--no-padd spc--top--med">
							<Collapsible expanded={true} title={t('ORDERDETAILVIEW.FULFILLMENTORDERITEMS')}>
								<FulfillmentOrderItemsList data={fulfillmentOrderItems.slice()} />
							</Collapsible>
						</div>
						<div className="spc--top--med">
							<Collapsible title={translate(['FULFILLMENTORDERVIEW.HISTORYLOG.VIEWACTIVITY'])}>
								<FulfillmentOrderHistoryLogList orderId={item.fulfillmentOrderId} />
							</Collapsible>
						</div>
					</div>
				</div>
			</div>
			<BaasicModal modalParams={errorLogModal}>
				<FulfillmentOrderErrorLogList
					orderId={item.fulfillmentOrderId}
					errorsList={item.fulfillmentOrderErrors}
					t={t}
					timezone={timezone}
					format={format}
				/>
			</BaasicModal>
			<BaasicModal modalParams={assignmentModal}>
				<AssignCarrierServiceAndWarehouse
					selectedItemId={item != null ? item.id : null}
					isDetailPage={true}
					parentViewStore={orderDetailViewStore}
				/>
			</BaasicModal>
			<BaasicModal modalParams={changeShippingModal}>
				<ChangeShipping selectedItemId={item != null ? item.id : null} parentViewStore={orderDetailViewStore} />
			</BaasicModal>
			<BaasicModal modalParams={editOrderModal}>
				<EditOrder selectedItemId={item != null ? item.id : null} parentViewStore={orderDetailViewStore} />
			</BaasicModal>
			<BaasicModal modalParams={onHoldModal}>
				<OnHold selectedItemId={item != null ? item.id : null} parentViewStore={orderDetailViewStore} />
			</BaasicModal>
			<BaasicModal modalParams={statusChangeModal}>
				<StatusChange selectedItemId={item != null ? item.id : null} parentViewStore={orderDetailViewStore} />
			</BaasicModal>

			<BaasicModal modalParams={voidLabelModal}>
				<VoidLabel selectedItemId={item != null ? item.id : null} parentViewStore={orderDetailViewStore} />
			</BaasicModal>
			<BaasicModal modalParams={neverShippedModal}>
				<NeverShipped selectedItemId={item != null ? item.id : null} parentViewStore={orderDetailViewStore} />
			</BaasicModal>
			<BaasicModal modalParams={markAsShippedModal}>
				<MarkAsShipped selectedItemId={item != null ? item.id : null} parentViewStore={orderDetailViewStore} />
			</BaasicModal>
			<BaasicModal className="ReactModal--lrg" modalParams={splitFulfillmentOrderModal}>
				<SplitFulfillmentOrder
					selectedItemId={item != null ? item.id : null}
					selectedMarketplaceOrderId={item != null ? item.orderId : null}
					modalParams={splitFulfillmentOrderModal}
					parentViewStore={orderDetailViewStore}
				/>
			</BaasicModal>
			<BaasicConfirmModal modalParams={cancelConfirmModal} />
			<BaasicConfirmModal modalParams={productionModeConfirmModal} />
			<BaasicConfirmModal modalParams={voidLabelConfirmModal} />
			<BaasicConfirmModal modalParams={pullLabelConfirmModal} />
			<BaasicConfirmModal modalParams={pullLabelProductionModeConfirmModal} />
			<BaasicConfirmModal modalParams={reoptimizeConfirmModal} />
			<iframe id="pdf-print" name="pdf-print" src={pdfURL} style={{ display: 'none' }}></iframe>
		</React.Fragment>
	);
};

const ActionsRender = observer(({ viewStore, t }) => {
	const { shouldDisplayActionButton } = viewStore;
	return (
		<div className="layout__title--flex--end">
			{shouldDisplayActionButton == false ? (
				<Actions viewStore={viewStore} t={t} />
			) : (
				<div className="popover" onClick={() => (viewStore.actionMenuOpen = !viewStore.actionMenuOpen)}>
					<button className={'popover__button popover__button--header' + (viewStore.actionMenuOpen ? ' active' : '')}>
						<i className="fa fa-cogs spc--right--tny" />
						<span className="spc--right--tny">{t('ACTIONS')}</span>
						<i className="fa fa-angle-down spc--left--sml" />
					</button>
					<div className={'popover__menu w--220--px' + (viewStore.actionMenuOpen ? ' active' : '')}>
						<ul>
							<Actions viewStore={viewStore} t={t} />
						</ul>
					</div>
				</div>
			)}
		</div>
	);
});

const Actions = observer(({ viewStore, t }) => {
	const {
		shouldDisplayActionButton,
		errorLogModal,
		assignmentModal,
		onHoldModal,
		changeShippingModal,
		cancelConfirmModal,
		statusChangeModal,
		markAsShippedModal,
		openEditOrderModal,
		openReoptimizeConfirmModal,
		isWarehouseAdministrator,
		hasLabel,
		isSeller,
		fulfillmentOrder,
		rootStore,
		fulfillmentOrderStore: { item },
		pullLabelConfirmModal,
		isSuperAdminOrganization,
		productionModeCheck,
		onProductionModeCheck,
		openVoidLabelModal,
		openNeverShippedConfirmModal,
		isBoxRequired,
		isVendorOrder,
		splitFulfillmentOrderModal,
		editFulfillmentOrderSplit,
	} = viewStore;
	return (
		<React.Fragment>
			{item.fulfillmentOrderErrors.length > 0 && (
				<div className="popover__menu__item">
					<button className="btn btn--white" type="button" onClick={() => errorLogModal.open()}>
						<i title={t('ERRORLOG')} className="fa fa-exclamation-circle spc--right--tny k-custom-clickable"></i>
						{t('ERRORLOG')}
					</button>
				</div>
			)}
			{/* Pull Label */}
			{(isWarehouseAdministrator || isSeller || isSuperAdminOrganization) &&
				!isBoxRequired &&
				!hasLabel &&
				rootStore.authStore.hasPiiAccess &&
				_.findIndex(onPullLabelStatuses, status => status == item.fulfillmentOrderStatus.abrv) != -1 && (
					<div className="popover__menu__item">
						<button
							className="btn btn--white"
							onClick={() =>
								pullLabelConfirmModal.open({
									message: ['ORDERVIEW.PULLLABELCONFIRM', { id: fulfillmentOrder.fulfillmentOrderId }],
								})
							}
						>
							<i title={t('PULLLABEL')} className="far fa-arrow-alt-circle-down spc--right--sml k-custom-clickable"></i>
							{t('PULLLABEL')}
						</button>
					</div>
				)}
			{/* Assign Carrier and Warehouse */}
			{_.findIndex(onAssignStatuses, status => status == item.fulfillmentOrderStatus.abrv) != -1 && (
				<div className="popover__menu__item">
					<button className="btn btn--white" type="button" onClick={() => assignmentModal.open()}>
						<i title={t('ASSIGN')} className="fa fa-tag spc--right--tny k-custom-clickable"></i>
						{t('FULFILLMENTORDER.ASSIGNMODAL.TITLE')}
					</button>
				</div>
			)}
			{/* On Hold */}
			{(isSeller || isSuperAdminOrganization) &&
				_.findIndex(onHoldStatuses, status => status == item.fulfillmentOrderStatus.abrv) != -1 && (
					<div className="popover__menu__item">
						<button className="btn btn--white" onClick={() => onHoldModal.open()}>
							<i title={t('ONHOLD')} className="fa fa-hand-paper spc--right--tny k-custom-clickable"></i>
							{t('ONHOLDVIEW.ONHOLD')}
						</button>
					</div>
				)}
			{/* Change shipping */}
			{(isSeller || isSuperAdminOrganization) &&
				!isVendorOrder &&
				(item.onHoldReason == null || item.onHoldReason.abrv != onHoldReason.toBeCancelled) &&
				_.findIndex(onChangeShippingStatuses, status => status == item.fulfillmentOrderStatus.abrv) != -1 && (
					<div className="popover__menu__item">
						<button className="btn btn--white" onClick={() => changeShippingModal.open()}>
							<i title={t('CHANGESHIPPING')} className="fa fa-exchange-alt spc--right--sml k-custom-clickable"></i>
							{t('CHANGESHIPPINGVIEW.TITLE')}
						</button>
					</div>
				)}
			{isSuperAdminOrganization &&
				((_.findIndex(onSplitFulfillmentOrderStatuses, status => status == item.fulfillmentOrderStatus.abrv) != -1 &&
					(item.fulfillmentOrderItems.length > 1 || item.fulfillmentOrderItems[0].quantity > 1)) ||
					editFulfillmentOrderSplit) && (
					<div className="popover__menu__item">
						<button className="btn btn--white" onClick={() => splitFulfillmentOrderModal.open(item)}>
							<i
								title={t(editFulfillmentOrderSplit ? 'EDITSPLITFULFILLMENTORDER' : 'SPLITFULFILLMENTORDER')}
								className="icon icon--grid-action icon--split--white spc--right--tny"
								onClick={() => splitFulfillmentOrderModal.open(item)}
							></i>
							{t(editFulfillmentOrderSplit ? 'EDITSPLITFULFILLMENTORDER' : 'SPLITFULFILLMENTORDER')}
						</button>
					</div>
				)}
			{/* Cancel */}
			{isSuperAdminOrganization &&
				_.findIndex(onCancelStatuses, status => status == item.fulfillmentOrderStatus.abrv) != -1 && (
					<div className="popover__menu__item">
						<button
							className="btn btn--white"
							onClick={() =>
								cancelConfirmModal.open({
									message: ['ORDERVIEW.CANCELFULFILLMENTORDER', { id: fulfillmentOrder.fulfillmentOrderId }],
								})
							}
						>
							<i
								title={t('CANCELFULFILLMENTORDER')}
								className="fa fa-window-close spc--right--tny k-custom-clickable"
							></i>
							{t('ORDERDETAILVIEW.CANCELFULFILLMENTORDER')}
						</button>
					</div>
				)}

			{/* Reoptimize */}
			{isSuperAdminOrganization &&
				_.findIndex(onReoptimizeStatuses, status => status == item.fulfillmentOrderStatus.abrv) != -1 && (
					<div className="popover__menu__item">
						<button className="btn btn--white" onClick={openReoptimizeConfirmModal}>
							<i
								title={t('REOPTIMIZE')}
								className="icon icon--grid-action icon--order-repeat--white spc--right--tny"
							></i>
							{t('REOPTIMIZE')}
						</button>
					</div>
				)}
			{/* Change Status */}
			{(isSeller || isSuperAdminOrganization) &&
				_.findIndex(onStatusChangeStatuses, status => status == item.fulfillmentOrderStatus.abrv) != -1 && (
					<div className="popover__menu__item">
						<button className="btn btn--white" onClick={() => statusChangeModal.open()}>
							<i title={t('CHANGESTATUS')} className="fa fa-undo spc--right--tny k-custom-clickable"></i>
							{t('CHANGESTATUS')}
						</button>
					</div>
				)}

			{/* Never Shipped */}
			{(isSeller || isSuperAdminOrganization) &&
				_.findIndex(onNeverShippedStatuses, status => status == item.fulfillmentOrderStatus.abrv) != -1 && (
					<div className="popover__menu__item">
						<button className="btn btn--white" onClick={openNeverShippedConfirmModal}>
							<i
								title={t('NEVERSHIPPED')}
								className="icon icon--grid-action icon--never-shipped--white spc--right--tny k-custom-clickable"
							></i>
							{t('NEVERSHIPPED')}
						</button>
					</div>
				)}
			{/* Mark as Shipped */}
			{(isSeller || isSuperAdminOrganization) &&
				_.findIndex(onMarkAsShippedStatuses, status => status == item.fulfillmentOrderStatus.abrv) != -1 && (
					<div className="popover__menu__item">
						<button className="btn btn--white" onClick={() => markAsShippedModal.open()}>
							<i title={t('MARKASSHIPPED')} className="fa fa-truck spc--right--tny k-custom-clickable"></i>
							{t('MARKASSHIPPED')}
						</button>
					</div>
				)}
			{/* Edit Order */}
			{(isSeller || isSuperAdminOrganization) && !hasLabel && rootStore.authStore.hasPiiAccess && (
				<div className="popover__menu__item">
					<button className="btn btn--white" type="button" onClick={openEditOrderModal}>
						<i title={t('EDIT')} className="fa fa-edit spc--right--tny k-custom-clickable"></i>
						{t('FULFILLMENTORDER.EDITMODAL.TITLE')}
					</button>
				</div>
			)}
			{/* Void Label */}
			{(isSeller || isSuperAdminOrganization) &&
			(isVendorOrder ? process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'staging' : true) && // Show VoidLabel for test environments for vendor
				!shouldDisplayActionButton &&
				hasLabel &&
				_.findIndex(voidLabelStatuses, status => status == item.fulfillmentOrderStatus.abrv) != -1 && (
					<div className="popover__menu__item">
						<button className="btn btn--white" onClick={() => openVoidLabelModal()}>
							<i title={t('VOIDLABEL')} className="fa fa-undo spc--right--tny k-custom-clickable"></i>
							{t('VOIDLABELVIEW.VOIDLABEL')}
						</button>
					</div>
				)}
			{/* Production Mode. */}
			{(isSeller || isSuperAdminOrganization) &&
				fulfillmentOrder.order.channel.channelType.abrv == 'amazon' &&
				rootStore.authStore.hasPiiAccess &&
				_.findIndex(onProductionModeStatuses, status => status == item.fulfillmentOrderStatus.abrv) != -1 &&
				process.env.NODE_ENV !== 'production' && (
					<div className="popover__menu__item--alt">
						<i title={t('ORDERVIEW.PRODUCTIONMODE')} className="icon icon--med icon--document-lock spc--right--tny"></i>
						<span>{t('ORDERVIEW.PRODUCTIONMODE')}</span>
						<div className="display--ib align--v--middle spc--left--tny">
							<BaasicCheckbox
								className={'input--toggle input--toggle--production'}
								id={'production-mode-toggle'}
								checked={productionModeCheck}
								onChange={event => onProductionModeCheck(event)}
							/>
						</div>
					</div>
				)}
		</React.Fragment>
	);
});

export default defaultTemplate(OrderDetailTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/order/pages/OrderDetailTemplate.jsx